export { Property1Variant7 } from "./Property1Variant7";
